import { adminHttpClient } from '../../commons/adminHttpClient'

export type TaxSavingsType = {
  familyMemberId: string | null
  user: {
    id: string
    name: string
  }
  relationship: {
    id: number
    name: string
  }
  items: {
    month: string
    status: number
    date: string
    providerName: string
  }[]
}

const getTaxSavings = (planPeriodId: string): Promise<{ months: string[]; users: TaxSavingsType[] }> => {
  return adminHttpClient.get(`Expenses/TaxSavings/${planPeriodId}`)
}

export default getTaxSavings
